import { useRequest } from "ahooks";
import { request } from "../../request";
import { addressToFormatting } from "./utils";

declare global {
  interface Window {
    _ADDRESS: ReturnType<typeof addressToFormatting>;
  }
}
/**
 * @name useAddressData 获取结构化的Address
 */
export default function useAddressData() {
  return useRequest(async () => {
    if (window._ADDRESS) return window._ADDRESS;
    const res = await request("/data/loanlimits"); // 在window缓存一份
    window._ADDRESS = addressToFormatting(res || []);
    return window._ADDRESS;
  });
}
